<script>
    export default {
        data: function () {
            return {
                error: false,
                form: true,
                success: false,
                successMessage: null,
                errorMessage: null
            }
        },
        mounted: function () {
            this.$refs.form.setAttribute('novalidate', true)

            // Check all fields on submit
            this.$refs.form.addEventListener('submit', (event) => {
                // Get all of the form elements
                var fields = event.target.elements

                // Validate each field
                // Store the first field with an error to a variable so we can bring it into focus later
                var error, hasErrors
                for (var i = 0; i < fields.length; i++) {
                    error = this.hasError(fields[i])
                    if (error) {
                        this.showError(fields[i])
                        if (!hasErrors) {
                            hasErrors = fields[i]
                        }
                    }
                }

                // If there are errrors, don't submit form and focus on first element with error
                if (hasErrors) {
                    hasErrors.focus()
                } else {
                    this.submitMailChimpForm(event.target)
                }

                event.preventDefault()
            }, false)
        },
        methods: {
            submitMailChimpForm: function (form) {
                var url = form.getAttribute('action')
                url = url.replace('/post?u=', '/post-json?u=')
                url += this.serialize(form) + '&c=displayMailChimpStatus'

                window.bus.$on('display-mailchimp-status', (data) => {
                    this.displayMailChimpStatus(data)
                })

                window.displayMailChimpStatus = function (data) {
                    window.bus.$emit('display-mailchimp-status', data)
                }

                var script = window.document.createElement('script')
                script.src = url

                // Insert script tag into the DOM (append to <head>)
                var ref = window.document.getElementsByTagName('script')[0]
                ref.parentNode.insertBefore(script, ref)

                // After the script is loaded (and executed), remove it
                script.onload = function () {
                    this.remove()
                }

                this.hideForm()
            },
            displayMailChimpStatus: function (data) {
                // If error, add error class
                if (data.result === 'error') {
                    this.showForm()
                    this.error = true
                    this.errorMessage = data.msg
                    return
                }

                this.successMessage = data.msg
                this.hideForm()
                this.success = true
            },
            serialize: function (form) {
                // Setup our serialized data
                var serialized = ''

                // Loop through each field in the form
                for (var i = 0; i < form.elements.length; i++) {
                    var field = form.elements[i]

                    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
                    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue

                    // Convert field data to a query string
                    if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                        serialized += '&' + encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
                    }
                }

                return serialized
            },
            hasError: function (field) {
                // Don't validate submits, buttons, file and reset inputs, and disabled fields
                if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button' || field.validity === undefined) return

                // Get validity
                var validity = field.validity

                // If valid, return null
                if (validity.valid) {
                    field.classList.remove('error')
                    return
                }

                return 'The value you entered for this field is invalid.'
            },
            showError: function (field) {
                // Add error class to field
                field.classList.add('error')

                // Use default error message
                this.errorMessage = null
                this.error = true
            },
            removeError: function (field) {
                // Remove error class to field
                field.classList.remove('error')
                this.error = false
            },
            hideForm: function () {
                this.$refs.form.parentNode.setAttribute('style', 'min-height: ' + this.$refs.form.getBoundingClientRect().height + 'px')
                this.form = false
            },
            showForm: function () {
                this.$refs.form.parentNode.setAttribute('style', '')
                this.form = true
            }
        }
    }
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// sv_cms/static/assets/vue/components/svnewsletter.vue